// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {getDebitTypes} from '../../shared/repositories';

export const readDebitTypes = (action, key) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getDebitTypes();

            dispatch({
                debitType: data.find(debitType => debitType.key === key),
                type: action
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/shared/action-creators/debit-types.js